import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n<path d=\"M29.5015 27.6636L11.9922 10.1543L10.6453 11.5012L28.1546 29.0105L29.5015 27.6636Z\" fill=\"currentColor\" />\n<path d=\"M11.5844 29.3443L29.0938 11.835L27.7469 10.4881L10.2376 27.9974L11.5844 29.3443Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol